import AmountConvert from 'common/amountConvert';

export class ChangeHistoryEmployeeData {
    private _employeeSourceId: string;
    private _displayName: string;
    private _currentPay: number;
    private _isoCurrencyCode: string;
    private _isHourly: boolean = false;
    private _annualStandardWorkHours: number;
    private _prorateRatio: number;
    private _fullTimeEquivalent: number;

    constructor(changeHistoryEmployeeDataDto: IChangeHistoryEmployeeData) {
        this._employeeSourceId = changeHistoryEmployeeDataDto.employeeSourceId;
        this._displayName = changeHistoryEmployeeDataDto.displayName;
        this._currentPay = changeHistoryEmployeeDataDto.currentPay;
        this._isoCurrencyCode = changeHistoryEmployeeDataDto.isoCurrencyCode;
        this._isHourly = changeHistoryEmployeeDataDto.isHourly;
        this._annualStandardWorkHours
            = changeHistoryEmployeeDataDto.annualStandardWorkHours
                ? changeHistoryEmployeeDataDto.annualStandardWorkHours
                : AmountConvert.annualStandardWorkHours;
        this._prorateRatio = changeHistoryEmployeeDataDto.prorateRatio ? changeHistoryEmployeeDataDto.prorateRatio : 0;
        this._fullTimeEquivalent
            = changeHistoryEmployeeDataDto.fullTimeEquivalent ? changeHistoryEmployeeDataDto.fullTimeEquivalent : 1;
    }

    get employeeSourceId(): string {
        return this._employeeSourceId;
    }

    get displayName(): string {
        return this._displayName;
    }

    get currentPay(): number {
        return this._currentPay;
    }

    get isoCurrencyCode(): string {
        return this._isoCurrencyCode;
    }

    get isHourly(): boolean {
        return this._isHourly;
    }

    get annualStandardWorkHours(): number {
        return this._annualStandardWorkHours;
    }

    get prorateRatio(): number {
        return this._prorateRatio;
    }

    get fullTimeEquivalent(): number {
        return this._fullTimeEquivalent;
    }

    currentPayWithFte(): number {
        return this._currentPay * this._fullTimeEquivalent;
    }
}
